import { InspectionReport } from '@/features/equipment/components/maintenance/inspections/inspection-logs/InspectionReport';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_frameless/fs/equipment/inspections/$inspection_id/inspection-logs/new',
)({
  component: InspectionReport,
});
